<app-spinner *ngIf="pageLoading"></app-spinner>

<ng-container *ngIf="!pageLoading">
  <div class="row justify-content-center mt-3">
    <div class="col-11 p-3 section-bc animation col-md-8 col-lg-6">
      <div class="row justify-content-center choise-area">
        <div class="col col-12 col-sm-8">
          <form [formGroup]="form">
            <div class="form-group" id="select-unity">
              <label for="customer">{{"PAGE.CLIENT_ACCOUNT_CHOICE.CUSTOMER" | translate}}</label>
              <div class="select-side">
                <i class="fas fa-caret-down"></i>
              </div>
              <select class="selectpicker show-tick form-control"
                      data-live-search="true"
                      id="customer"
                      data-size="5"
                      width="fit"
                      [attr.data-none-selected-text]="'PAGE.CLIENT_ACCOUNT_CHOICE.FORMS.LABELS.NO_CLIENT_SELECTED' | translate"
                      [attr.data-none-results-text]="'PAGE.CLIENT_ACCOUNT_CHOICE.FORMS.NO_RESULTS' | translate"
                      [attr.title]="'select-option' | translate"
                      [formControl]="form.get('customer')"
                      [formControlName]="'customer'"
                      [ngClass]="{'is-invalid': !form.get('customer').valid && form.get('customer').dirty}"
                      (ngModelChange)="onClienteSelected($event)"
              >
              <ng-container *ngFor="let c of clients">
                  <option [value]="c.customerCode"
                          [selected]="clientSelected === c.customerCode">{{c.customerCode + (c.businessName ? ' - ' + c.businessName : '')}}</option>
                </ng-container>
              </select>
              <app-error-label [control]="form.get('customer')" [errors]="formErrors.customer"></app-error-label>
            </div>

            <div class="form-group">
              <label for="account">{{"PAGE.CLIENT_ACCOUNT_CHOICE.ACCOUNT" | translate}}</label>
              <div class="select-side" *ngIf="!accountsLoading">
                <button type="button" style="background: none; border: none" (click)="resetAccount()" *ngIf="accountSelected">
                  <em class="far fa-window-close"></em>
                </button>
                <i class="fas fa-caret-down"></i>

              </div>
              <div class="input-side-spinner spinner-border" role="status" *ngIf="accountsLoading">
                <span class="sr-only">Loading...</span>
              </div>
              <select class="selectpicker show-tick form-control"
                      data-live-search="true"
                      id="account"
                      data-size="5"
                      width="fit"
                      [attr.data-none-selected-text]="'PAGE.CLIENT_ACCOUNT_CHOICE.FORMS.LABELS.NO_ACCOUNT_SELECTED' | translate"
                      [attr.data-none-results-text]="'PAGE.CLIENT_ACCOUNT_CHOICE.FORMS.NO_RESULTS' | translate"
                      [attr.title]="'select-option' | translate"
                      [formControl]="form.controls['account']"
                      [formControlName]="'account'"
                      [ngClass]="{'is-invalid': !form.get('account').valid && form.get('account').dirty}"
                      (ngModelChange)="onAccountSelected($event)"
              >
                <ng-container *ngFor="let a of accounts">
                  <option [value]="a.accountCode"
                          [selected]="accountSelected === a.accountCode">{{a.accountCode + (a.description ? ' - ' + a.description : '')}}</option>
                </ng-container>
              </select>
              <app-error-label [control]="form.get('account')" [errors]="formErrors.account"></app-error-label>
            </div>
          </form>
        </div>
        <div class="col col-12 col-sm-4">
          <app-tree [treeData]="tree.structure" *ngIf="tree"></app-tree>
        </div>
      </div>
    </div>
  </div>

</ng-container>
<div *ngIf="showButtons" class="row w-100 justify-content-center mt-3">
  <button id="login-btn" type="button" class="btn btn-primary m-2" (click)="accedi()"
          [disabled]="isFormInvalid()">{{'BUTTON.ENTER' | translate}}
  </button>
  <button type="button" class="btn btn-outline-danger m-2" (click)="logout()">{{'SIDEBAR.USER.LOGOUT' | translate}}
  </button>
</div>
